{
    "Rules_Validation_MustBeANumber": "Deve essere un numero",
    "Rules_Validation_MustBeAnInteger": "Deve essere un numero intero",
    "Rules_Validation_MustBeGreaterThanZero": "Deve essere maggiore di zero",
    "Rules_Validation_EmailMustBeValid": "L'e-mail deve essere valida",
    "Rules_Validation_MustBeLessThanMaxSafeInteger": "Maggiore del valore massimo consentito",
    "Rules_Validation_MustBeLessThanLimit": "Deve essere inferiore a {}",
    "Rules_Validation_MustMatch": "Deve corrispondere",
    "Rules_Validation_MinLength": "Deve essere lungo almeno {} caratteri",
    "Rules_Numbers_MaxSafeInteger": "il valore intero massimo",
    "NAME": "RulesLanguage",
    "Rules_Validation_ValidUrl": "Deve essere un URL valido",
    "Rules_Validate_Empty": "Questo campo è obbligatorio",
    "Rules_Validation_MaxLength": "Deve essere lungo al massimo {} caratteri",
    "Rules_Validation_MaxWordLength": "Ogni parola deve essere lunga al massimo {} caratteri",
    "Rules_Validation_IncorrectPattern": "Il valore fornito non è valido",
    "Rules_Validation_Unique": "Il valore deve essere univoco",
    "Rules_Validation_ContentType": "Il tipo di contenuto deve essere uno dei seguenti: {}",
    "Rules_Validation_MustBeUnderLimit": "Deve essere inferiore a {}"
}